import { PageWrapper, SuiTable } from '@britishcouncil/react-admin';
import { useTableState } from 'hooks/useTableState';

import {
  useGetTrainingAndStandardisationReportRecordsQuery,
  TrainingAndStandardisationFilterType,
  useGenerateTrainingAndStandardisationPdfReportMutation,
  useGenerateTrainingAndStandardisationExcelReportMutation,
} from 'store';
import { TableState } from 'types';
import { TrainingAndStandardisationReportRecordDto } from 'api';
import { columns } from './TrainingAndStandardisationReportColumns';
import { ReportExportButton } from '../common';
import { TrainingAndStandardisationReportFiltersBar } from './TrainingAndStandardisationReportFilters';

export const TrainingAndStandardisationReport = () => {
  const { tableState, setTableState, setFilterState } = useTableState(initialTableState);
  const { filters, ...pagingAndSortingState } = tableState;
  const { data, isFetching } = useGetTrainingAndStandardisationReportRecordsQuery(tableState, {
    skip: !filters.standardisedNotCertified && (!filters.date?.[0] || !filters.date?.[1]),
  });

  const [generatePdf, { isLoading: isPdfLoading }] =
    useGenerateTrainingAndStandardisationPdfReportMutation();
  const [generateExcel, { isLoading: isExcelLoading }] =
    useGenerateTrainingAndStandardisationExcelReportMutation();

  return (
    <PageWrapper
      mainActions={
        <ReportExportButton
          disabled={data?.results === undefined || data.totalCount === 0}
          fileName="training-and-standardisation"
          generatePdf={() => generatePdf(tableState)}
          isPdfLoading={isPdfLoading}
          generateExcel={() => generateExcel(tableState)}
          isExcelLoading={isExcelLoading}
        />
      }
      mainActionsAbove
    >
      <TrainingAndStandardisationReportFiltersBar
        setFilterState={setFilterState}
        initialFilterState={initialTableState.filters}
      />
      <SuiTable
        columns={columns}
        data={data?.results ?? []}
        disableFilters
        onStateChange={setTableState}
        loading={isFetching}
        state={pagingAndSortingState}
        totalCount={data?.totalCount}
        tableRowProps={(_, { row }) => ({
          negative: row.original.isStandardisedNotCertified,
        })}
        cellWhiteSpace="normal"
      />
    </PageWrapper>
  );
};

const initialTableState: TableState<
  TrainingAndStandardisationReportRecordDto,
  TrainingAndStandardisationFilterType
> = {
  pageIndex: 0,
  pageSize: 20,
  sortBy: [],
  filters: {
    standardisedNotCertified: false,
  },
};
